// extracted by mini-css-extract-plugin
module.exports = {"query":"Searchtem_query__x7m7w","queryLabel":"Searchtem_queryLabel__wBs35"};